// @flow
const sorterByPrice: Sorter = {
  selected: false,
  id: 'best-price',
  name: 'sortByBestPrices',
  path: 'totalDifferentialPrice.value',
};

const sorterByRecommendation: Sorter = {
  selected: false,
  id: 'recommendation',
  name: 'sortByRecommendation',
  path: '',
};

export { sorterByPrice, sorterByRecommendation };
